export enum EventStatusEnum {
    Draft = 0,
    Active = 1,
    Inactive = 2,
}
